
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class LoaderService {
    public status: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    display(value: boolean) {
        this.status.next(value);
    }
}


// WEBPACK FOOTER //
// C:/Ajatus WorkSpace/Now Grocery/now-grocery/NowGroceryStoreFront/src/app/_shared/services/loader.service.ts